import { CLOSE_BOOKING } from "../actions/types";

export default (iShow = false, action) => {
  if (action.type === CLOSE_BOOKING) {
    return action.payload;
  }
  return iShow;
};
